import { render, staticRenderFns } from "./PatientCreateOrder.vue?vue&type=template&id=16c8a92a&scoped=true"
import script from "./PatientCreateOrder.vue?vue&type=script&lang=js"
export * from "./PatientCreateOrder.vue?vue&type=script&lang=js"
import style0 from "./PatientCreateOrder.vue?vue&type=style&index=0&id=16c8a92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c8a92a",
  null
  
)

export default component.exports